import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { Wrapper, IconWrapper, Dot } from "./styles/messages-styles";
import * as storage from "../../../storage";

const Messages = (props) => {
  const { unreadMessagesCount, messagesUrl } = props;

  const handleLink = () => {
    window.location.href = messagesUrl;
  };

  const handleMessagesLink = () => {
    storage.local.removeItem("conversations-list-mobile-hidden", "mobile-out");
    storage.local.setItem("conversations-list-mobile-shown", "mobile-in");
  };

  return (
    <Wrapper>
      <IconWrapper
        onClick={() => {
          handleLink();
          handleMessagesLink();
        }}
      >
        <FontAwesomeIcon icon={faComments} />
        {unreadMessagesCount > 0 && <Dot />}
      </IconWrapper>
    </Wrapper>
  );
};

Messages.propTypes = {
  unreadMessagesCount: PropTypes.number.isRequired,
  messagesUrl: PropTypes.string.isRequired,
};

export default Messages;
